import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as api from '../../apiUtils/api';
import * as taskActions from '../../redux/tasks/actions';
import getApiHost from '../../apiUtils/apiHost';

class TaskRender extends Component {
    
    componentDidMount(){
        this.checkAndVerifyTaskTimerId = setInterval(
            () => this.checkAndVerifyAcceptedTask(),
            10000
        )
    }

    componentWillMount(){
        window.addEventListener('message', this.iframeReady, false)
        window.addEventListener('message', this.useBrowserResolution, false)
        window.addEventListener('resize', this.postDimensions, false)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.iframeReady, false)
        window.removeEventListener('resize', this.postDimensions, false)
        clearInterval(this.checkAndVerifyTaskTimerId);
    }

    handleFrameLoaded() {
        let frame = document.getElementById('idIframe')
        //frame.height = '2791px'
        frame.height= window.innerHeight || documentElement.clientHeight || body.clientHeight
    }

    checkAndVerifyAcceptedTask(){
        const auth=this.props.auth;
        const taskDist=this.props.taskDist;
        const that=this;
        if (auth && taskDist){
            //console.log('checkAndVerifyAcceptedTask call api');
            api.getAcceptTaskInfo(this.props.auth.jwtToken,this.props.taskDist.taskAcceptedInfo.id).then((res) => res.json()).then((data)=>{
                //to be continue
                //console.log('checkAndVerifyAcceptedTask: '+ JSON.stringify(data));
                if (data){
                    if (!data.taskAcceptedWorker){
                        //reset state
                        that.props.taskCompleted();
                    }
                }
            }).catch((err)=>{
                console.log(err);
            })
        }
    }

    iframeReady = e => {
        if (e.data === 'ready') {
          this.postDimensions()
          const frameWrapper = document.getElementById('frameWrapper')
          //temporary - comment 
          //if (!frameWrapper.classList.contains('frame-wrapper-force-wrap')) {
          //  frameWrapper.classList.add('frame-wrapper-force-wrap')
          //}
          //const iframeContainer = document.getElementById('iframeContainer')
          //if (!iframeContainer.classList.contains('container-fluid')) {
          //  iframeContainer.classList.remove('container')
          //  iframeContainer.classList.add('container-fluid')
          //}
        }
    }
  
    useBrowserResolution = e => {
        if (e.data === 'useBrowserResolution') {
            this.iframeUseBrowserResolution = true
        }
    }
  
    postDimensions = () => {
        //console.log('postDimensions')
        let w = window,
            d = document,
            documentElement = d.documentElement,
            body = d.getElementsByTagName('body')[0],
            width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
            height = w.innerHeight || documentElement.clientHeight || body.clientHeight

        let iframeWin = document.getElementById('idIframe').contentWindow
        
        iframeWin.postMessage(
            JSON.stringify({
            type: 'postDimensions',
            width: width,
            height: height,
            }),
            '*'
        )
        let frame = document.getElementById('idIframe')

        if (this.iframeUseBrowserResolution) {
            frame.width = `${width}px`
            frame.height = `${height + 225}px`
        }
    }

    render(){
        if (!this.props.taskDist.taskAcceptedInfo){
            return <Redirect to='/dashboard' />;
        }
        
        let renderUrl=this.props.taskDist.taskAcceptedInfo.task_rendered_url;
        if (renderUrl){
            renderUrl+=`&jwt=${this.props.auth.jwtToken}`
            renderUrl+=`&apiHost=${getApiHost()}`
            renderUrl+=`&taskAcceptedInfoId=${this.props.taskDist.taskAcceptedInfo.id}`
        }
        renderUrl = renderUrl.replace(new RegExp("#", 'g'), "%23")
        return (
            <div className="animated fadeIn">
                  <iframe
                    key={'frame' + new Date().getTime()}
                    id="idIframe"
                    scrolling={'true'}
                    onLoad={this.handleFrameLoaded.bind(this)}
                    className="col-md-12 col-lg-12 col-sm-12 col-xs-12"
                    frameBorder="0"
                    src={renderUrl}
                />
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
      auth: state.auth,
      taskDist: state.taskDist
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      taskCompleted: () => {
         dispatch(taskActions.taskCompleted())  
      }
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(TaskRender);


// WEBPACK FOOTER //
// ./src/views/TaskRender/TaskRender.js